import React from 'react';
import PropTypes from 'prop-types';
import { NoData } from 'rp-react-table';

import Accordion from '../../shared/Accordion';
import BigRaceWins from './bigRaceWins/BigRaceWins';
import StatsTable from './statsTable/StatsTable';

const Stats = ({ data: { bigRaceWins, stats }, params }) => (
    <section>
        <Accordion
            header="stats"
            initialExpanded
        >
            { stats ?
                <StatsTable
                    data={stats}
                    params={params}
                /> : <NoData text="No stats found" />
            }
        </Accordion>
        <Accordion header="big race wins">
            <BigRaceWins
                data={bigRaceWins}
                type={params.type}
            />
        </Accordion>
    </section>
);


Stats.defaultProps = {
    data: {
        stats: {
            seasonInfo: {},
        },
        bigRaceWins: [],
    },
};

Stats.propTypes = {
    data: PropTypes.shape({
        stats: PropTypes.object,
        statsResponse: PropTypes.object,
        bigRaceWins: PropTypes.arrayOf(PropTypes.shape({
            raceDate: PropTypes.string,
            raceInstanceTitle: PropTypes.string,
            horseStyleName: PropTypes.string,
            jockeyStyleName: PropTypes.string,
            prizeSterling: PropTypes.number,
            trainerStyleName: PropTypes.string,
        })),
    }).isRequired,
    params: PropTypes.shape({
        id: PropTypes.string,
        type: PropTypes.string,
    }).isRequired,
};

export default Stats;



// WEBPACK FOOTER //
// ./src/js/human/stats/Stats.jsx